/**
 * 'Role.filter'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

export default (value) => {
  return {
    'branch_chief': 'Gerente de Sucursal',
    'dealer_chief': 'Director de Distribuidor',
    'pollster': 'Evaluador',
    'super_admin': 'Superadministrador',
    'dealer': 'Distribuidor'
  }[value] || value
}



// WEBPACK FOOTER //
// ./src/filters/role.filter.js